    varying float vPositionAlongLine;

    void main() {
        //vPositionAlongLine = position.z; // Assuming the line runs along the x-axis
        vPositionAlongLine = (position.z) ; // Assuming the line runs along the x-axis from -5 to 5
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }